<section class="p-2">
    <div class="w-100" [innerHTML]="dieuKhoan"></div>
</section>